export default "__VITE_ASSET__95ef2bab__"